export default {
  0: {
    desc: "中国联通",
    upgrade_cpu1: "OB",
    upgrade_fw: "JB",
    ip: "",
  },
  1: {
    desc: "中国电信",
    upgrade_cpu1: "OC",
    upgrade_fw: "JC",
    ip: "117.60.157.137",
  },
  2: {
    desc: "中国移动",
    upgrade_cpu1: "ON", // cpu升级对应的关键字
    upgrade_fw: "JD", // NB模组升级对应的关键字
    ip: "115.231.31.15", // 运营商ip
  },
  3: {
    desc: "中国铁塔",
    upgrade_cpu1: "",
    upgrade_fw: "",
    ip: "",
  },
  4: {
    desc: "电信CTWING",
    pgrade_cpu1: "OC",
    upgrade_fw: "JC",
    ip: "117.60.157.137",
  },
  5: {
    desc: "联通格物（全国）",
    upgrade_cpu1: "OB",
    upgrade_fw: "JB",
    ip: "",
  },
  6: {
    desc: "立方联通",
    upgrade_cpu1: "",
    upgrade_fw: "",
    ip: "",
  },
  7: {
    desc: "立方电信",
    upgrade_cpu1: "",
    upgrade_fw: "",
    ip: "",
  },
  8: {
    desc: "立方移动",
    upgrade_cpu1: "",
    upgrade_fw: "",
    ip: "",
  },
};
